import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddIcon from "@mui/icons-material/Add";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import ContactDetailList from "../../AiLeads/ContactDetailList/ContactDetailList";
import Tooltip from "@mui/material/Tooltip";
import { useLocation, useNavigate } from "react-router-dom";
import RightSidebar from "../../RightSiderbar/RightSiderbar";
import axios from "axios";
import Loader from "../../Loader/Loader";
import { toast } from "react-toastify";
import hoveridentifier from "../../../Assets/hoverindentifier.svg"
import moment from "moment";
import activeSaleforceLogo from "../../../Assets/activeSaleforceLogo.svg"
import { Modal } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import {
    APISalesforceUrl,
    APIDataUrl,
    APITokenUrl,
    APIGraphUrl,
    getConfidenceScore,
    GetOktaAuthData,
    GetUserId,
} from "../../../Utils/Utils";
import * as XLSX from "xlsx";
import { useState } from "react";
import IndustryDropdown from "../../AiLeads/IndustrySectorDropdown/Index";
import starRed from "../../../Assets/starRed.svg"
import Stargrey from "../../../Assets/Stargrey.png"
import MessageModal from "../../MessageModal/MessageModal";
import sortingimg from "../../../Assets/sortingarrow.svg"
import syncsorting from "../../../Assets/syncsorting.svg"
import SouthIcon from '@mui/icons-material/South';
import NorthIcon from '@mui/icons-material/North';
import AddToFavoritePeopleModal from "../../FavoritesList/AddToFavoriteModal/AddToFavoritePeopleModal";
import AddToFavoriteOrgModal from "../../FavoritesList/AddToFavoriteModal/AddToFavoriteOrgModal";
import LeadsProspectModal from "../../RequestUpdateModals/LeadsProspectModal";
import SalesForceMessageModal from "../../MessageModal/SalesForceMessageModal";
function Row({
    key,
    row,
    onSelect,
    ExpandHandler,
    expandHandlerAccept,
    selectedRows,
    setSelectedRows,
    setPageInner,
    pageInner,
    openRowId,
    hasMoreInner,
    onLoadApi,
    setHasMoreInner,
    setopenRowId,
    totalPages,
    setRowsSelectOuter,
    handleArchiveRecords,
    selectedOuterRows, searchResultsList, setSearchResultsList, listOrganizationSearchResults, handleRowSelect, showLeadsProspects
}) {

    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    const [innerTableData, setInnerTAbleData] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [openSidebar, setOpenSidebar] = React.useState(false);
    const [dataShortestPath, setDataShortestPath] = React.useState();
    const [userDetails, setUserDetails] = useState();
    const [scrollPagination, setScrollPagination] = useState(false);

    const loggedInUserId = GetUserId();
    const handleRightsidebar = (event) => {
        const data = {};
        data.source_uid = Number(loggedInUserId);
        data.target_uid = Number(event?.person_id);
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APITokenUrl()
            },
            data: data,
            url: `${APIGraphUrl()}/v1/shortest-path`,
        };
        axios(option)
            .then((response) => {
                if (response?.status === 200) {
                    const data = Object.values(response.data);
                    setDataShortestPath(data);
                    setOpenSidebar(true);
                    setUserDetails(event);
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message);
            });
    };

    const getColor = (aiScore) => {
        if (aiScore > 80) {
            return "green";
        } else if (aiScore >= 50 && aiScore <= 80) {
            return "yellow";
        } else {
            return "red";
        }
    };
    const color = getColor(row.ai_score);
    const [rowsSelect, setRowsSelect] = useState(false);
    const handleAllSelectCollapsible = () => {
        if (rowsSelect) {
            const newList = innerTableData
                ?.map((info) => ({ ...info, organizationInfo: row }))
            setSelectedRows(newList);
        } else {
            setSelectedRows([]);
        }
    };

    const onExpand = (event) => {
        setLoading(true);
        onLoadApi(event)
            .then((e) => {
                const childData = e;
                getStrength(childData, true);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    const ExpandHandlerChild = (event) => {
        setLoading(true);
        ExpandHandler(event)
            .then((e) => {
                const childData = e;
                getStrength(childData);

                setLoading(false);
                if (e?.status === 200) {
                    const innerdata = e?.data?.data;
                }
            })
            .catch(() => {
                setLoading(false);
            });
    };

    React.useEffect(() => {
        if (expandHandlerAccept?.length > 0) {
            setInnerTAbleData([...expandHandlerAccept]);
        }
    }, [expandHandlerAccept]);

    const getStrength = async (childData, isExpand) => {
        if (!childData?.length) {
            setLoading(false);
            return;
        }
        setLoading(true);

        const tuples = childData?.map((item) => ({
            items: [loggedInUserId?.toString(), item.person_id?.toString()],
        }));
        const data = { tuples };
        const options = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APITokenUrl()
            },
            data: data,
            url: `${APIGraphUrl()}/v1/conn_strength`,
        };

        try {
            const response = await axios(options);
            const strengthData = response?.data;

            const updatedData = childData?.map((item, index) => ({
                ...item,
                strengthData: strengthData[index],
            }));

            if (isExpand) {
                setInnerTAbleData([...updatedData]);
            } else {
                setInnerTAbleData([...innerTableData, ...updatedData]);
            }

            if (open) {
            } else {
                setOpen(!open);
            }
        } catch (error) {
            setLoading(false);
            toast.error(error?.response?.data?.message);
        } finally {
            setTimeout(() => {
                setLoading(false);
                setScrollPagination(true);
            }, 0);
            setTimeout(() => {
                setHasMoreInner(true);
            }, 1000);
        }
    };

    const clickHandler = (event) => {
        navigate(`/companyprofilescreen/${event?.org_id}/0`);
    };
    const clickHandlerProfile = (event) => {
        navigate(`/Profile/${event?.person_id == 0 ? "0" : event?.person_id}`)
        // onClick={() => { navigate(`/Profile/${row?.person_id == 0 ? "0" : row?.person_id}`) }} style={{cursor:'pointer'}}
    }

    React.useEffect(() => {
        if (
            innerTableData?.length >= 50 &&
            row.org_id === openRowId &&
            pageInner > 1 &&
            pageInner <= Math.ceil(pages)
        ) {
            setHasMoreInner(false);
            ExpandHandlerChild(openRowId);
        }
    }, [pageInner]);

    const isChecked = (id) => {
        return selectedRows.some((info) => info.person_id === id);
    };

    const pages = row.people_count / 50;
    const closeExpandHandler = () => {
        setInnerTAbleData([]);
        setOpen(false);
        setopenRowId("");
        setScrollPagination(false);
    };

    React.useEffect(() => {
        handleAllSelectCollapsible();
    }, [rowsSelect]);
    const ref = React.useRef(null);
    const isBranchLocationsDisabled = true;

    const loadMore = () => {
        setLoading(true);
        setPageInner(prevPageInner => prevPageInner + 1);
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    };
    const handleFavouriteLead = (row) => {
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APITokenUrl()
            },
            data: [row.org_id],
            url: `${APIDataUrl()}/favorites/org/add-record?user_id=${GetUserId()}`,
        };
        axios(option)
            .then(async (response) => {
                setLoading(false);
                listOrganizationSearchResults(true)
                toast.success(response.data?.message);
                // toast.success("Organization added to favorites")
                // if (response?.data?.already_existing.length) {
                //     toast.error(response.data.already_existing[0].message);
                // } else {
                //     toast.success(response.data?.message);
                // }
            })
            .catch(() => {
                setLoading(false);
            });
    }
    const handleRemoveFavouriteLead = (row) => {
        setLoading(true)
        const option = {
            method: "DELETE",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APITokenUrl()
            },
            url: `${APIDataUrl()}/favorites/delete_favorites_org?user_id=${loggedInUserId}`,
            data: [row.org_id],
        };
        axios(option)
            .then(async (response) => {
                setLoading(false);
                toast.success("Organization removed from favorites")
                listOrganizationSearchResults(true);
            })
            .catch(() => {
                setLoading(false);
            });
    }
    return (
        <React.Fragment key={key}>
            {loading ? <Loader /> : null}
            <TableRow
                sx={{ "& > *": { borderBottom: "unset" } }}
                style={{ cursor: "pointer" }}
            >
                <>
                    <TableCell className="checkbox-row-table-inner checkbox-row-table">
                        <div className="kjhgf">
                            {
                                showLeadsProspects === "pros" ?
                                    <input
                                        type="checkbox"
                                        disabled
                                    /> :
                                    <input
                                        type="checkbox"
                                        onChange={() => handleRowSelect(row)}
                                        checked={selectedOuterRows.some(item => item.org_id === row?.org_id)}
                                    />
                            }
                        </div>
                    </TableCell>
                    <TableCell
                        component="th"
                        scope="row"
                    >
                        <>
                            {
                                row?.isFavourite ?
                                    <div className="kjhgf" onClick={() => handleRemoveFavouriteLead(row)}>
                                        <img src={starRed} alt="" />
                                    </div> :
                                    <div className="kjhgf" onClick={() => handleFavouriteLead(row)}>
                                        <img src={Stargrey} alt="" />
                                    </div>
                            }
                        </>
                    </TableCell>
                    <TableCell
                        component="th"
                        scope="row"
                        onClick={() => clickHandler(row)}
                    >
                        <div className="kjhgf">
                            <div
                                className="ai-score-background"
                                style={{
                                    background:
                                        color === "red"
                                            ? "#001A54"
                                            : color === "yellow"
                                                ? "#EAB121"
                                                : color === "green"
                                                    ? "#0EB93E"
                                                    : null,
                                }}
                            >
                                {/* {row.ai_score ? row.ai_score : "-"} */}
                                {row?.ai_score !== null && row?.ai_score !== undefined
                                    ? row?.ai_score
                                    : "NA"}
                            </div>
                        </div>
                    </TableCell>
                    <TableCell
                        align="left"
                        className="companylocation"
                        onClick={() => clickHandler(row)}
                    >
                        <h3 className="company-name-country-prospect">
                            {row.name ? row.name : "-"}
                        </h3>
                        <p className="after-company-name-country-prospect">
                            {row.city ? row.city : ""}, {row?.state ? row?.state : "-"}
                        </p>
                    </TableCell>
                    <TableCell align="center" onClick={() => clickHandler(row)}>
                        <div className="section-employee-size">
                            <h3 className="employee-size-table">
                                {row.num_employees ? row.num_employees : "-"}
                            </h3>
                        </div>
                    </TableCell>
                    <TableCell align="left" onClick={() => clickHandler(row)}>
                        <h3 className="annual-revenue-table">
                            {row?.revenue_range ? row?.revenue_range : "-"}
                        </h3>
                    </TableCell>
                    <TableCell
                        align="left"
                        className="table-cell-of-contact-details-dropdown-th"
                    >
                        <div
                            className="Set-dropdown-ofIndustry"
                            style={{ position: "relative" }}
                        >
                            <div className="email-andrelative-other-info">
                                <div className="maked-component-of-dropdown-forai-leads">
                                    <IndustryDropdown row={row} />
                                </div>
                            </div>
                        </div>
                    </TableCell>
                </>
                <TableCell align="left" onClick={() => clickHandler(row)}>
                    <h3 className="employee-size-table">
                        {row.people_count ? row.people_count : "-"}
                    </h3>
                </TableCell>
                <TableCell className="collapse-expand-main-header">
                    <Tooltip title={open ? "Collapse" : "Expand"}>
                        {open ? (
                            <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => closeExpandHandler()}
                                className="button-collapse-table-main"
                            >
                                <RemoveRoundedIcon className="icon-collapse-table" />
                            </IconButton>
                        ) : (
                            <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => {
                                    setInnerTAbleData([]);
                                    setHasMoreInner(false);
                                    setTimeout(() => {
                                        if (openRowId !== row?.org_id) {
                                            setLoading(true);
                                            setPageInner(1);
                                            onExpand(row?.org_id);
                                        }
                                    }, 0);
                                }}
                                className="button-collapse-table-main"
                            >
                                <AddIcon className="icon-collapse-table" />
                            </IconButton>
                        )}
                    </Tooltip>

                </TableCell>


                <TableCell
                >
                    <td style={{ position: "relative" }}> {/* Ensures proper positioning */}
                        <div className="hover-container-prospects">
                            <img src={hoveridentifier} alt="" className="hover-image-prospects" />

                            <div
                                className={`hover-content-prospects ${(!row?.updated_at || !row?.confidence_score) ? "no-update-prospects" : "has-update-prospects"
                                    }`}
                            >
                                <div className="data-sync-c-rate-prospects">
                                    <div className="datasync-line-c-score-prospects">
                                        <span className="datasync-line-prospects">Data Sync: </span>
                                        <span className="datasync-line-data-prospects">
                                            {row?.updated_at
                                                ? moment(row.updated_at).format("MM.DD.YY")
                                                : "No update information available"}
                                        </span>
                                    </div>
                                    <div className="datasync-line-c-score-prospects">
                                        <span className="datasync-line-prospects">Data Confidence Score:</span>
                                        <span className="datasync-line-data-prospects">
                                            {row?.confidence_score
                                                ? getConfidenceScore(row.confidence_score)
                                                : "No update information available"}
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </td>

                </TableCell >
            </TableRow>
            {
                innerTableData?.length ?
                    <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                <Box
                                    sx={{ margin: 1 }}
                                    id="scrollableDiv"
                                    className="ai-leads-table-inner"
                                    ref={ref}
                                >
                                    <TableContainer component={Paper}>
                                        <Table
                                            aria-label="collapsible table"
                                            className="ai-leads-table"
                                        >
                                            <TableHead>
                                                <TableRow className="row-head">
                                                    <TableCell className="checkbox-row-table-inner checkbox-row-table">
                                                        {
                                                            showLeadsProspects === "leads" ?
                                                                <input
                                                                    type="checkbox"
                                                                    disabled
                                                                /> :
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={(e) => setRowsSelect(e?.target?.checked)}
                                                                    checked={rowsSelect}
                                                                />
                                                        }
                                                    </TableCell>
                                                    <TableCell className="empty-name-and-title">
                                                    </TableCell>

                                                    <TableCell className="company-row-table-inner-name-and-other">
                                                        <p className="title-name-inner-lead-table">Name & Title</p>
                                                    </TableCell>
                                                    <TableCell
                                                        align="left"
                                                        className="score-row-table-New-Data"
                                                    >
                                                        Orbit Strength
                                                    </TableCell>
                                                    <TableCell
                                                        align="left"
                                                        className="employee-row-table-innerIndustryAndSector"
                                                    >
                                                        <p className="sector-industry"> Industry/ Sector</p>
                                                    </TableCell>
                                                    <TableCell
                                                        align="left"
                                                        className="annual-row-table-status"
                                                    >
                                                        Orbit Status
                                                    </TableCell>
                                                    <TableCell align="left" className="industry-row-table-inner-table">
                                                        Contact details
                                                    </TableCell>
                                                    <TableCell
                                                        align="left"
                                                        className="industry-row-table-inner-table-last"
                                                    ></TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {innerTableData
                                                    ?.slice()
                                                    ?.sort((a, b) => {
                                                        if (a.decision_maker && !b.decision_maker) return -1;
                                                        if (!a.decision_maker && b.decision_maker) return 1;
                                                        return (b.strengthData?.strength || 0) - (a.strengthData?.strength || 0);
                                                    })
                                                    ?.map((item, index) => {
                                                        const firstName = item?.first_name;
                                                        const lastName = item?.last_name;
                                                        const decision_maker = item.decision_maker === true;
                                                        const concatedName = `${firstName ? firstName.charAt(0) : ""}${lastName ? lastName.charAt(0) : ""}`;
                                                        const isSelected = isChecked(item.person_id);

                                                        return (
                                                            <React.Fragment key={index}>
                                                                <TableRow key={index} sx={{ "& > *": { borderBottom: "unset" } }}>
                                                                    <TableCell className="checkbox-row-table">
                                                                        {showLeadsProspects === "leads" ? (
                                                                            <input type="checkbox" disabled />
                                                                        ) : (
                                                                            <input type="checkbox" checked={isSelected} onChange={() => onSelect(item)} />
                                                                        )}
                                                                    </TableCell>
                                                                    <TableCell align="left" className="empty-name-and-title"
                                                                        onClick={() => clickHandlerProfile(item)} style={{ cursor: 'pointer' }}
                                                                    >
                                                                        <div className="name-title-inner-table-ofAi-leads">
                                                                            <div className="relation-section-inner">
                                                                                <div className={decision_maker ? "decision-maker-class" : "create-name-img"}>
                                                                                    <p className="name-heading">{concatedName}</p>
                                                                                    <img
                                                                                        className={item.suspect_status === null ? "hide-image" : "../images/salesforce-logo.svg"}
                                                                                        src={
                                                                                            item?.journey_status === "project created"
                                                                                                ? activeSaleforceLogo
                                                                                                : "../images/salesforce-logo.svg"
                                                                                        } alt=""
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell align="left" className="company-row-table-inner-name-and-other" onClick={() => clickHandlerProfile(item)} style={{ cursor: 'pointer' }}>
                                                                        <div className="name-title-inner-table-ofAi-leads">
                                                                            <div className="relation-section-inner">
                                                                                <div className="name-and-designation">
                                                                                    <p className="name-in-acordian">
                                                                                        {`${item?.first_name || "-"} ${item?.last_name || "-"}`}
                                                                                    </p>
                                                                                    <div className="job-title-container">
                                                                                        <div className="tooltip-container-jobtitle">
                                                                                            <p className={item?.raw_job_title ? "tooltip-highlights-jobtitle" : "tooltip-highlights-jobtitle-none"}>
                                                                                                {item?.raw_job_title}
                                                                                            </p>
                                                                                            <p className="designation-in-acordian">
                                                                                                {item?.primary_job_title?.length
                                                                                                    ? item?.primary_job_title.length > 20
                                                                                                        ? item?.primary_job_title.substr(0, 20) + "..."
                                                                                                        : item?.primary_job_title
                                                                                                    : "-"}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" onClick={() => clickHandlerProfile(item)} style={{ cursor: 'pointer' }}>
                                                                        <p className="j-strength-cell">
                                                                            {item?.strengthData?.strength || "-"}
                                                                        </p>
                                                                    </TableCell>
                                                                    <TableCell align="left" className="table-cell-of-contact-details-dropdown-th" onClick={() => clickHandlerProfile(item)} style={{ cursor: 'pointer' }}>
                                                                        <div className="Set-dropdown-ofIndustry" style={{ position: "relative" }}>
                                                                            <div className="email-andrelative-other-info">
                                                                                <div className="maked-component-of-dropdown-forai-leads">
                                                                                    <IndustryDropdown row={row} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell align="left" onClick={() => clickHandlerProfile(item)} style={{ cursor: 'pointer' }}>
                                                                        <div className="suspect-and-arrow-in-accordian">
                                                                            <p>{item?.suspect_status || "-"}</p>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell align="left" className="table-cell-of-contact-details-dropdown-th">
                                                                        <div className="Set-dropdown-ofContactDetailList" style={{ position: "relative" }}>
                                                                            <div className="email-and-other-infodc">
                                                                                <div className="maked-component-of-dropdown">
                                                                                    <ContactDetailList item={item} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell className="left-arrow-main-cell-container">
                                                                        <IconButton className="egberh" aria-label="expand row" size="small">
                                                                            <RightSidebar
                                                                                handleRightsidebar={handleRightsidebar}
                                                                                rowid={item}
                                                                                dataShortestPath={dataShortestPath}
                                                                                openSidebar={openSidebar}
                                                                                userDetails={userDetails}
                                                                            />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                            </TableBody>
                                        </Table>
                                        {/* </InfiniteScrollMain> */}
                                    </TableContainer>
                                    {
                                        innerTableData?.length >= 50 ?
                                            <div className="loadmore-pagination-section">
                                                {totalPages !== pageInner && <button className="btn-load-more button-loadmore-pagination" onClick={loadMore} disabled={loading}>{loading ? 'Loading...' : 'Load More'}</button>}
                                            </div> : null
                                    }

                                </Box>
                            </Collapse>
                        </TableCell>
                    </TableRow> : null
            }
        </React.Fragment>
    );
}
Row.propTypes = {
    row: PropTypes.shape({
        calories: PropTypes.number.isRequired,
        carbs: PropTypes.number.isRequired,
        fat: PropTypes.number.isRequired,
        history: PropTypes.arrayOf(
            PropTypes.shape({
                amount: PropTypes.number.isRequired,
                customerId: PropTypes.string.isRequired,
                date: PropTypes.string.isRequired,
            })
        ).isRequired,
        name: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        protein: PropTypes.number.isRequired,
    }).isRequired,
    selected: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
};

export default function OrganizationSearchResultsTable({
    setIsDecisionMakerExcel,
    isDecisionMakerExcel, setIsSalesForceTrigger,
    isSalesForceTrigger, archiveRecord,
    setArchiveRecord, loading, setLoading, trackRecord,
    requestUpdateRecord, setRequestUpdateRecord, setDisableRequestUpdate,
    setTrackRecord, selectedOuterRows, setSelectedOuterRows,
    setShowSalesForce, showLeadsProspects, selectedRows,
    setSelectedRows, trackingData, handleTrackingdata,
    totalCount, setTotalCount, addToFav, setAddToFav
}) {
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 450,
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "8px",
    };
    const [successModel, setSuccessModel] = React.useState("");
    const location = useLocation()
    const userInfo = GetOktaAuthData();
    const loggedUser = userInfo?.user?.profile;
    const [hasMoreInner, setHasMoreInner] = React.useState(false);
    const [expandHandlerAccept, setExpandHandlerAccept] = useState([]);
    const [pageInner, setPageInner] = React.useState(1);
    const [openRowId, setopenRowId] = useState("");
    const [totalPages, setTotalPages] = useState(10);
    const [rowsSelectOuter, setRowsSelectOuter] = React.useState({});
    const [searchResultsList, setSearchResultsList] = React.useState([])
    const [hitApi, setHitApi] = React.useState(false)
    const [hitApiInner, setHitApiInner] = React.useState(false)
    const [rowsSelectAll, setRowsSelectAll] = React.useState(false)
    const [messageModal, setMessageModal] = useState(false)
    const [messageModalTrack, setMessageModalTrack] = React.useState(false)
    const [messageModalSalesforce, setMessageModalSalesforce] = React.useState(false)
    const [skip, setSkip] = useState(0)
    const [sortOrder, setSortOrder] = React.useState(null);
    const [sortField, setSortField] = React.useState("");
    const prevLocationState = React.useRef(location.state);
    const [query, setQuery] = React.useState(location.state);
    const [openCreateListmdl, setOpenCreateListmdl] = React.useState(false);
    const [requestUpdateModal, setRequestUpdateModal] = React.useState(false)


    React.useEffect(() => {
        if (location.state !== prevLocationState.current) {
            setSearchResultsList([]);
        }
        prevLocationState.current = location.state;
        setQuery(location.state);
    }, [location.state]);
    //get search list results
    const listOrganizationSearchResults = async (isFav) => {
        setLoading(true)
        const options = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APITokenUrl()
            },
            data: { "org_name": query },
            url: `${APIDataUrl()}/v1/universal_search_org?skip=${skip * 50}&limit=50`,
        };
        try {
            const response = await axios(options);
            setTotalCount(response?.data?.total_records)
            if (isFav) {
                setSearchResultsList([...response?.data?.data])
            } else {
                setSearchResultsList([...searchResultsList, ...response?.data?.data])
            }
        } catch (error) {
            setLoading(false);
            toast.error(error?.response?.data?.message);
        } finally {
            setLoading(false);
        }
    }

    React.useEffect(() => {
        listOrganizationSearchResults()
    }, [skip, query])

    // pagination 
    const loadMore = () => {
        setLoading(true);
        setSkip(prev => prev + 1);
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    };
    //sorting
    const handleSort = (field) => {
        let newSortOrder;
        if (sortField === field) {
            newSortOrder = sortOrder === "asc" ? "desc" : "asc";
        } else {
            newSortOrder = "asc";
        }
        setSortOrder(newSortOrder);
        setSortField(field);

        const employeeOrder = [
            "1-10", "11-50", "51-100", "101-250", "251-500", "501-1000",
            "1K-5K", "5K-10K", "10K+"
        ];

        const revenueOrder = [
            "$0-$1m", "$0-$1M", "$1m-$10m", "$1M-$10M", "$10m-$50m", "$10M-$50M", "$50m-$100m", "$50M-$100M",
            , "$100m-$500m", "$100M-$500M", "$500m-$1b", "$500M-$1B", "$1b-$10b", "$1B-$10B", "$10b+", "$10B+"
        ];

        const getOrderIndex = (value, orderArray) => {
            const index = orderArray.indexOf(value);
            return index !== -1 ? index : orderArray.length;
        };

        const sortedData = [...searchResultsList].sort((a, b) => {
            let aValue = field.includes(".")
                ? field.split(".").reduce((acc, key) => acc?.[key], a)
                : a[field];
            let bValue = field.includes(".")
                ? field.split(".").reduce((acc, key) => acc?.[key], b)
                : b[field];

            const isEmpty = (val) => val === null || val === "" || val === "-";
            const aIsEmpty = isEmpty(aValue);
            const bIsEmpty = isEmpty(bValue);

            if (aIsEmpty && !bIsEmpty) return 1;
            if (!aIsEmpty && bIsEmpty) return -1;
            if (aIsEmpty && bIsEmpty) return 0;

            if (field === "updated_at") {
                aValue = new Date(aValue);
                bValue = new Date(bValue);
            }

            if (field === "num_employees") {
                return newSortOrder === "asc"
                    ? getOrderIndex(aValue, employeeOrder) - getOrderIndex(bValue, employeeOrder)
                    : getOrderIndex(bValue, employeeOrder) - getOrderIndex(aValue, employeeOrder);
            }

            if (field === "revenue_range") {
                return newSortOrder === "asc"
                    ? getOrderIndex(aValue, revenueOrder) - getOrderIndex(bValue, revenueOrder)
                    : getOrderIndex(bValue, revenueOrder) - getOrderIndex(aValue, revenueOrder);
            }

            if (typeof aValue === "number" && typeof bValue === "number") {
                return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
            }

            if (typeof aValue === "string" && typeof bValue === "string") {
                return newSortOrder === "asc"
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            }

            if (aValue instanceof Date && bValue instanceof Date) {
                return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
            }

            return 0;
        });

        setSearchResultsList(sortedData);
    };
    //expand inner handler
    const ExpandHandler = (event, page) => {
        setopenRowId(event);

        const option = {
            method: "GET",
            headers: {
                "content-type": "plain/text",
                "X-API-Key": APITokenUrl()
            },
            url: `${APIDataUrl()}/v1/decision_maker?org_id=${event}&limit=50&skip=${(pageInner - 1) * 50}`,
        };
        return axios(option).then((e) => {
            if (e?.status === 200) {
                setTotalPages(10)
                const innerdata = e?.data?.data;
                if (innerdata?.length === 0) {
                    setHasMoreInner(false);
                }
                return innerdata;
            }

            return e;
        });
    };
    //load more records in inner handler
    const onLoadApi = (event) => {
        setopenRowId(event);

        const option = {
            method: "GET",
            headers: {
                "content-type": "plain/text",
                "X-API-Key": APITokenUrl()
            },
            url: `${APIDataUrl()}/v1/decision_maker?org_id=${event}&limit=50&skip=${0}`,
        };
        return axios(option).then((e) => {
            if (e?.status === 200) {
                const innerdata = e?.data?.data;
                if (innerdata?.length === 0) {
                    setHasMoreInner(false);
                } else {
                }
                return innerdata;
            }

            return e;
        });
    };
    //push to salesforce inner records
    const validateSalesforce = () => {
        if (!selectedRows || selectedRows?.length === 0) {
            toast.error("Please Select Records For Push To Salesforce");
            setIsSalesForceTrigger(false)
            return false;
        }
        return true;
    };

    //validate and hit salesforce
    React.useEffect(() => {
        if (isSalesForceTrigger) {
            if (!validateSalesforce()) return;
            if (hitApiInner == true) {
                setMessageModalSalesforce(true)
            }
        }
    }, [isSalesForceTrigger]);
    // enable disable salesforce button or not 
    React.useEffect(() => {
        if (selectedRows?.length) {
            const data = selectedRows?.filter((item) => item.suspect_status !== null)
            if (data?.length) {

                setShowSalesForce("disable")
            } else {
                setShowSalesForce("show")
            }
        } else {
            setShowSalesForce(false)
        }
    }, [selectedRows])

    //select organization table rows
    const handleRowSelect = (row) => {
        setSelectedOuterRows(prevSelectedRows => {
            const isAlreadySelected = prevSelectedRows.some(item => item.org_id === row.org_id);

            if (isAlreadySelected) {
                return prevSelectedRows.filter(item => item.org_id !== row.org_id);
            } else {
                return [...prevSelectedRows, row];
            }
        });
    };
    //select organization table all rows
    React.useEffect(() => {
        if (rowsSelectAll) {
            const allRows = [...searchResultsList];
            setSelectedOuterRows(allRows);
        } else if (rowsSelectAll === false) {
            setSelectedOuterRows([]);
        } else if (selectedOuterRows?.length == searchResultsList?.length) {
            setRowsSelectAll(true)
        } else if (selectedOuterRows?.length < searchResultsList?.length) {
            setRowsSelectAll(false)
        }
    }, [rowsSelectAll, rowsSelectOuter]);
    // if outer table row selected then api can hit 
    React.useEffect(() => {
        if (selectedOuterRows?.length) {
            setHitApi(true)
        } else {
            setHitApi(false)
        }
    }, [selectedOuterRows])
    // if inner table row selected then api can hit 
    React.useEffect(() => {
        if (selectedRows?.length) {
            setHitApiInner(true)
        } else {
            setHitApiInner(false)
        }
    }, [selectedRows])
    //handle track outer organization records
    const handleTrackRecords = () => {
        if (!selectedOuterRows?.length) {
            toast.error("Please select records to track")
            setTrackRecord(false)
            return
        } else {
            setLoading(true);
            const filteredData = selectedOuterRows.filter((selectedItem) =>
                !trackingData.some(
                    (trackingItem) => Number(selectedItem.org_id) === Number(trackingItem.org_id)
                )
            );

            if (filteredData.length === 0) {
                toast.error("All selected records are already tracked.");
                setLoading(false);
                return;
            }

            const data = filteredData.map(item => item?.org_id);
            // const data = selectedOuterRows.map(item => item?.org_id);
            const option = {
                method: "POST",
                headers: {
                    "access-control-allow-origin": "*",
                    "X-API-Key": APITokenUrl()
                },
                data: data,
                url: `${APIDataUrl()}/v1/save_tracking_organization?user_id=${Number(GetUserId())}`,
            };
            axios(option)
                .then((response) => {
                    if (response.status === 200) {
                        setLoading(false);
                        setTrackRecord(false)
                        setSelectedOuterRows([])
                        toast.success("Tracking Added")
                        setMessageModalTrack(false);
                        handleTrackingdata();
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    toast.error(error.response.data.message);
                });
        }
    }

    //handle track inner prospects records
    const handleTrackPeopleRecords = () => {
        setLoading(true);
        const filteredData = selectedRows.filter((selectedItem) =>
            !trackingData.some(
                (trackingItem) => Number(selectedItem.person_id) === Number(trackingItem.person_id)
            )
        );

        if (filteredData.length === 0) {
            toast.error("All selected records are already tracked.");
            setLoading(false);
            return;
        }

        const data = filteredData.map(item => item?.person_id);
        // const data = selectedOuterRows.map(item => item?.person_id);
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "X-API-Key": APITokenUrl()
            },
            data: data,
            url: `${APIDataUrl()}/v1/save_tracking_prospect?user_id=${Number(GetUserId())}`,
        };
        axios(option)
            .then((response) => {
                if (response.status === 200) {
                    setLoading(false);
                    setTrackRecord(false)
                    setSelectedRows([])
                    setMessageModalTrack(false)
                    toast.success("Tracking Added")
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error(error.response.data.message);
            });

    }
    // check which modal to call 
    React.useEffect(() => {
        if (trackRecord === true) {
            if (showLeadsProspects === "leads") {
                if (hitApi === true) {
                    setMessageModalTrack(true);
                    setTrackRecord(false);
                }
                return;
            } else if (showLeadsProspects === "pros") {
                if (hitApiInner === true) {
                    setMessageModalTrack(true);
                    setTrackRecord(false);
                }
            } else {
                toast.error("Please select records to track");
                setTrackRecord(false);
                return;
            }

        }

    }, [trackRecord]);

    const handleRemoveFavouriteLead = (row) => {
        // setLoading(true)
        // const data = searchResultsList?.find(item => item?.org_id == row?.org_id)
        // const option = {
        //     method: "POST",
        //     headers: {
        //         "access-control-allow-origin": "*",
        //         "content-type": "application/json",
        //         "X-API-Key": APITokenUrl()
        //     },
        //     // data: data,
        //     url: `${APIDataUrl()}/v1/remove_favourite_leads?id=${data?.favourites_id}`,
        // };
        // axios(option)
        //     .then(async (response) => {
        //         setLoading(false);
        //         // toast.success("Organization removed from favorites")
        //     })
        //     .catch(() => {
        //         setLoading(false);
        //     });
    }

    // archive records
    React.useEffect(() => {
        if (archiveRecord === true) {
            if (showLeadsProspects === "leads") {
                if (hitApi === true) {
                    setMessageModal(true);
                    setArchiveRecord(false);
                }
                return;
            } else if (showLeadsProspects === "pros") {
                if (hitApiInner === true) {
                    setMessageModal(true);
                    setArchiveRecord(false);
                }
            } else {
                toast.error("Please select records to Archive");
                setArchiveRecord(false);
                return;
            }

        }
    }, [archiveRecord])
    const handleArchiveRecords = async () => {
        setLoading(true)

        await Promise.all(selectedOuterRows.map(i => handleRemoveFavouriteLead(i)));

        const data = selectedOuterRows.map(item => ({
            user_id: Number(GetUserId()),
            org_id: item?.org_id,
        }));

        const options = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APITokenUrl(),
            },
            data: data,
            url: `${APIDataUrl()}/v1/send_archive`,
        };

        try {
            const response = await axios(options);

            setArchiveRecord(false);
            setMessageModal(false);
            setSelectedOuterRows([]);
            listOrganizationSearchResults(true)
            if (response?.data?.message === "Already archived") {
                toast.success("Organization already archived.");
            } else {
                toast.success("Organization archived successfully.");
            }
            setLoading(false)

        } catch (error) {
            setLoading(false)
            toast.error(error?.response?.data?.message || "Failed to archive organization.");
        }
    };
    const handleArchiveProspectsRecords = async () => {
        setLoading(true)

        await Promise.all(selectedRows.map(i => handleRemoveFavouriteLead(i)));
        const data = selectedRows.map(item => ({
            user_id: Number(GetUserId()),
            people_id: item?.person_id
        }));

        const options = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                "X-API-Key": APITokenUrl()
            },
            data: data,
            url: `${APIDataUrl()}/v1/send_archive`,
        };
        try {
            const response = await axios(options);
            setMessageModal(false)
            setArchiveRecord(false)
            setSelectedRows([])
            if (response?.data?.message === "Already archived") {
                toast.success("Prospects already Archived.")
            } else {
                toast.success("Prospects Archived Successfully")
            }
            setLoading(false)

        } catch (error) {
            setLoading(false)
            toast.error(error?.response?.data?.message);

        } finally {
        }

    }
    // add to favorites
    React.useEffect(() => {
        if (addToFav === true) {
            if (showLeadsProspects === "leads") {
                if (hitApi === true) {
                    setOpenCreateListmdl(true);
                    setAddToFav(false);
                }
                return;
            } else {
                toast.error("Please select records to add To Favorites");
                setAddToFav(false);
                return;
            }

        }
    }, [addToFav])

    React.useEffect(() => {
        if (selectedOuterRows?.length < 1 && requestUpdateRecord == true) {
            setDisableRequestUpdate(false)
            setRequestUpdateRecord(false)
            toast.error("Please select record to request update")
            return
        } else if (selectedOuterRows?.length === 1 && requestUpdateRecord == true) {
            setRequestUpdateModal(true)
            setRequestUpdateRecord(false)
            setDisableRequestUpdate(false)
        } else if (selectedOuterRows?.length > 1 && requestUpdateRecord == true) {
            setDisableRequestUpdate(false)
            setRequestUpdateRecord(false)
            toast.error("Please select only one record to request update")
        } else {
            setDisableRequestUpdate(false)
        }
    }, [selectedOuterRows, requestUpdateRecord])
    return (
        <React.Fragment>
            {searchResultsList?.length ? (
                <>
                    <TableContainer component={Paper} className="ai-leads-table-main">

                        <Table aria-label="collapsible table" className="ai-leads-table">
                            <TableHead>
                                <TableRow className="table-row-ai-leads">
                                    <TableCell className="score-row-table">Select</TableCell>
                                    <TableCell className="score-row-table">Favorite</TableCell>
                                    <TableCell className="score-row-table">
                                        <p className="prospect-Name-and-Title-leads">
                                            Orbit Score {""}
                                            {sortField === "ai_score" ? (
                                                sortOrder === "asc" ? (
                                                    <NorthIcon
                                                        style={{ fontSize: "10px", cursor: "pointer" }}
                                                        onClick={() => handleSort("ai_score")}
                                                    />
                                                ) : (
                                                    <SouthIcon
                                                        style={{ fontSize: "10px", cursor: "pointer" }}
                                                        onClick={() => handleSort("ai_score")}
                                                    />
                                                )
                                            ) : (
                                                <img
                                                    src={sortingimg}
                                                    alt=""
                                                    onClick={() => handleSort("ai_score")}
                                                    className="sorting-arrow-leadsprofile"
                                                />
                                            )} </p> </TableCell>
                                    <TableCell align="left" className="company-row-table">
                                        Organization & location {""}
                                        {sortField === "name" ? (
                                            sortOrder === "asc" ? (
                                                <NorthIcon
                                                    style={{ fontSize: "10px", cursor: "pointer" }}
                                                    onClick={() => handleSort("name")}
                                                />
                                            ) : (
                                                <SouthIcon
                                                    style={{ fontSize: "10px", cursor: "pointer" }}
                                                    onClick={() => handleSort("name")}
                                                />
                                            )
                                        ) : (
                                            <img
                                                src={sortingimg}
                                                alt=""
                                                onClick={() => handleSort("name")}
                                                className="sorting-arrow-leadsprofile"
                                            />
                                        )}                  </TableCell>
                                    <TableCell align="left" className="employee-row-table">
                                        Employee size {""}
                                        {sortField === "num_employees" ? (
                                            sortOrder === "asc" ? (
                                                <NorthIcon
                                                    style={{ fontSize: "10px", cursor: "pointer" }}
                                                    onClick={() => handleSort("num_employees")}
                                                />
                                            ) : (
                                                <SouthIcon
                                                    style={{ fontSize: "10px", cursor: "pointer" }}
                                                    onClick={() => handleSort("num_employees")}
                                                />
                                            )
                                        ) : (
                                            <img
                                                src={sortingimg}
                                                alt=""
                                                onClick={() => handleSort("num_employees")}
                                                className="sorting-arrow-leadsprofile"
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell align="left" className="annual-row-table">
                                        Annual revenue {""}
                                        {sortField === "revenue_range" ? (
                                            sortOrder === "asc" ? (
                                                <NorthIcon
                                                    style={{ fontSize: "10px", cursor: "pointer" }}
                                                    onClick={() => handleSort("revenue_range")}
                                                />
                                            ) : (
                                                <SouthIcon
                                                    style={{ fontSize: "10px", cursor: "pointer" }}
                                                    onClick={() => handleSort("revenue_range")}
                                                />
                                            )
                                        ) : (
                                            <img
                                                src={sortingimg}
                                                alt=""
                                                onClick={() => handleSort("revenue_range")}
                                                className="sorting-arrow-leadsprofile"
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell align="left" className="industry-row-table">
                                        <p className="sector-industry-inner-new">  Industry/ Sector {""}
                                            {sortField === "categories" ? (
                                                sortOrder === "asc" ? (
                                                    <NorthIcon
                                                        style={{ fontSize: "10px", cursor: "pointer" }}
                                                        onClick={() => handleSort("categories")}
                                                    />
                                                ) : (
                                                    <SouthIcon
                                                        style={{ fontSize: "10px", cursor: "pointer" }}
                                                        onClick={() => handleSort("categories")}
                                                    />
                                                )
                                            ) : (
                                                <img
                                                    src={sortingimg}
                                                    alt=""
                                                    onClick={() => handleSort("categories")}
                                                    className="sorting-arrow-leadsprofile"
                                                />
                                            )}</p>
                                    </TableCell>
                                    <TableCell align="left" className="industry-row-table">
                                        <p className="industry-row-Inner">Employees {""}
                                            {sortField === "people_count" ? (
                                                sortOrder === "asc" ? (
                                                    <NorthIcon
                                                        style={{ fontSize: "10px", cursor: "pointer" }}
                                                        onClick={() => handleSort("people_count")}
                                                    />
                                                ) : (
                                                    <SouthIcon
                                                        style={{ fontSize: "10px", cursor: "pointer" }}
                                                        onClick={() => handleSort("people_count")}
                                                    />
                                                )
                                            ) : (
                                                <img
                                                    src={sortingimg}
                                                    alt=""
                                                    onClick={() => handleSort("people_count")}
                                                    className="sorting-arrow-leadsprofile"
                                                />
                                            )} </p>
                                    </TableCell>
                                    <TableCell align="left" className=""></TableCell>
                                    <TableCell>
                                        {sortField === "updated_at" ? (
                                            sortOrder === "asc" ? (
                                                <NorthIcon
                                                    className="sync-sorting-img-d-maker"
                                                    onClick={() => handleSort("updated_at")}
                                                />
                                            ) : (
                                                <SouthIcon
                                                    className="sync-sorting-img-d-maker"
                                                    onClick={() => handleSort("updated_at")}
                                                />
                                            )
                                        ) : (
                                            <img
                                                src={syncsorting}
                                                alt=""
                                                onClick={() => handleSort("updated_at")}
                                                className="sync-sorting-img"
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {searchResultsList?.map((row, index) => {
                                    const isSelected = selectedRows?.find(
                                        (item) => item?.person_id === row?.person_id
                                    );
                                    return (
                                        <React.Fragment key={index}>
                                            <Row
                                                key={row.name}
                                                row={row}
                                                selected={isSelected}
                                                onSelect={(selectedRow) => {
                                                    const localRows = [...selectedRows];
                                                    const selectedIndex = localRows.findIndex(
                                                        (row) => row?.person_id === selectedRow?.person_id
                                                    );
                                                    let newSelected = [];
                                                    if (selectedIndex === -1) {
                                                        newSelected = [selectedRow];
                                                    } else if (selectedIndex === 0) {
                                                        newSelected = newSelected.concat(
                                                            localRows.slice(1)
                                                        );
                                                    } else if (selectedIndex === localRows.length - 1) {
                                                        newSelected = newSelected.concat(
                                                            localRows.slice(0, -1)
                                                        );
                                                    } else if (selectedIndex > 0) {
                                                        newSelected = localRows.filter(
                                                            (child) =>
                                                                child.person_id !== selectedRow.person_id
                                                        );
                                                    }
                                                    const updatedOrganizations = newSelected.map(
                                                        (name) => {
                                                            const organization = searchResultsList.find(
                                                                (org) => org?.org_id === name?.org_id
                                                            );
                                                            return {
                                                                ...name,
                                                                organizationInfo: organization,
                                                            };
                                                        }
                                                    );
                                                    setSelectedRows(
                                                        selectedIndex > -1
                                                            ? updatedOrganizations
                                                            : [...selectedRows, ...updatedOrganizations]
                                                    );
                                                }}
                                                connectionStrength={row.connectionStrength}
                                                handleArchiveRecords={handleArchiveRecords}
                                                ExpandHandler={ExpandHandler}
                                                onLoadApi={onLoadApi}
                                                expandHandlerAccept={expandHandlerAccept}
                                                selectedRows={selectedRows}
                                                setSelectedRows={setSelectedRows}
                                                setPageInner={setPageInner}
                                                pageInner={pageInner}
                                                openRowId={openRowId}
                                                hasMoreInner={hasMoreInner}
                                                setExpandHandlerAccept={setExpandHandlerAccept}
                                                setopenRowId={setopenRowId}
                                                setHasMoreInner={setHasMoreInner}
                                                totalPages={totalPages}
                                                setRowsSelectOuter={setRowsSelectOuter}
                                                selectedOuterRows={selectedOuterRows}
                                                searchResultsList={searchResultsList}
                                                setSearchResultsList={setSearchResultsList}
                                                listOrganizationSearchResults={listOrganizationSearchResults}
                                                handleRowSelect={handleRowSelect}
                                                showLeadsProspects={showLeadsProspects}
                                            />
                                        </React.Fragment>
                                    );
                                })}

                            </TableBody>

                        </Table>
                    </TableContainer>
                </>
            ) : (
                <div className="ai-leads-table-main">
                    <div className="ai-leads-no-data-available-outter">
                        <div className="ai-leads-no-data-available">
                            No Data Available
                        </div>
                    </div>
                </div>
            )
            }
            <div className="loadmore-pagination-section">
                {totalCount !== searchResultsList?.length && <button className="btn-load-more button-loadmore-pagination" onClick={loadMore} disabled={loading}>{loading ? 'Loading...' : 'Load More'}</button>}
            </div>
            <MessageModal open={messageModal} setOpen={setMessageModal}
                message={`Are you sure that you want to archive ${(selectedRows?.length > 0
                    ? (selectedRows?.length > 0 ? "these records" : "this record")
                    : (selectedOuterRows?.length > 0 ? "these records" : "this record"))
                    }?`}
                length={selectedRows?.length > 0 ? selectedRows?.length : selectedOuterRows?.length}
                handleSubmit={selectedRows?.length > 0 ? handleArchiveProspectsRecords : handleArchiveRecords} />

            <MessageModal
                open={messageModalTrack}
                setOpen={setMessageModalTrack}
                message={`Are you sure that you want to add ${(selectedRows?.length > 0
                    ? (selectedRows?.length > 0 ? "these records" : "this record")
                    : (selectedOuterRows?.length > 0 ? "these records" : "this record"))
                    } to tracking?`}
                handleSubmit={selectedRows?.length > 0 ? handleTrackPeopleRecords : handleTrackRecords}
                length={selectedRows?.length > 0 ? selectedRows?.length : selectedOuterRows?.length}
            />

            {/* <MessageModal open={messageModalSalesforce}
                setOpen={setMessageModalSalesforce}
                message={`Are you sure that you want to push ${selectedRows?.length > 1 ? "these records" : "this record"} to Salesforce?`}
                handleSubmit={pushToSalesForce} length={selectedRows?.length} /> */}
            <SalesForceMessageModal open={messageModalSalesforce} setOpen={setMessageModalSalesforce} selectedOuterRows={selectedRows} setSelectedOuterRows={setSelectedRows} setIsSalesForceTrigger={setIsSalesForceTrigger} decisionMakerData={searchResultsList} setLoading={setLoading} />

            <AddToFavoriteOrgModal open={openCreateListmdl} setOpen={setOpenCreateListmdl}
                selectedOuterRows={selectedOuterRows} setSelectedOuterRows={setSelectedOuterRows}
                message={`Are you sure that you want to add ${selectedOuterRows?.length > 1 ? "these records" : "this record"} to Favorites?`}
                handleApply={() => listOrganizationSearchResults(true)} />

            <LeadsProspectModal requestUpdateRecord={requestUpdateModal}
                setSuccessModel={setSuccessModel}
                successModel={successModel}
                setRequestUpdateRecord={setRequestUpdateModal}
                profileData={selectedOuterRows[0]} peopleId={selectedOuterRows?.[0]?.org_id}
                setSelectedOuterRows={setSelectedOuterRows} />
            <Modal
                open={successModel == true}
                onClose={() => setSuccessModel(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className="vrufyerv">
                    <Box sx={style} style={{ overflowY: "auto", width: "30%", }}>
                        <div className='de_pad_req-up'>
                            <p className='cross-people-req-model'><ClearIcon onClick={() => setSuccessModel(false)} /></p>
                            <p className='de_head'>Your Record Update request has been successfully submitted. The Orbit Team will review your request and notify you when the record has been updated.</p>
                        </div>
                    </Box>
                </div>
            </Modal>
        </React.Fragment >
    );
}
